import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class TagAPI extends ComponentAPI {
    getColor() {
        return this.state.color;
    }
    setColor(color) {
        this.setState({ color });
    }
    getValue() {
        return this.state.value;
    }
    setValue(value) {
        this.setState({ value });
    }
}
export default TagAPI;
//# sourceMappingURL=tag-api.js.map